<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import ZxdjBrowse from "./ZxdjBrowse";
import ZxdjEdit from "./ZxdjEdit";
import ZxdjForm from "./ZxdjForm";
export default {
    name: "Zxdj",
    components: { ZxdjBrowse, ZxdjEdit, ZxdjForm },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showEdit: false,
                showForm: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showEdit === true) {
                return "ZxdjEdit";
            } else if (this.editProps.showForm === true) {
                return "ZxdjForm";
            } else {
                return "ZxdjBrowse";
            }
        }
    }
};
</script>
